module.exports = __webpack_public_path__ + "static/media/4_Standing up on the inside_AF.3e2aa7dc.txt";